import client from './client';

/**
 * 먹킷 사업주 대시보드 SSO 토큰 발급 요청
 * 보안: licenseKey 는 본인 인증 용도로 body 전송. 토큰은 1분 만료.
 */
export interface MucketSsoTokenResponse {
  token: string;
  redirectUrl: string;
  expiresIn: number;
}

export async function issueMucketSsoToken(
  licenseKey: string,
): Promise<MucketSsoTokenResponse> {
  const response = await client.post<MucketSsoTokenResponse>(
    '/api/integrations/mucket/sso-token',
    { licenseKey },
  );
  return response.data;
}
